export default "<span class=\"twp-story-status-icon\">\n  <i class=\"fa {{$ctrl.class}}\" aria-hidden=\"true\"></i>\n</span>";